/** 게시글 공유 채팅 메시지 포맷 — [GIG_INVITE:v1] 패턴과 동일 구조 */

export const POST_SHARE_CHAT_PREFIX = '[POST_SHARE:v1]';

/**
 * @param {{ id: number, title: string, authorNickname: string, thumbnailUrl: string }} post
 * @returns {string}
 */
export function buildPostShareChatMessage(post) {
  return POST_SHARE_CHAT_PREFIX + JSON.stringify({
    id: post.id,
    title: post.title,
    authorNickname: post.authorNickname,
    thumbnailUrl: post.thumbnailUrl ?? '',
  });
}

/**
 * @param {string} content
 * @returns {{ id: number, title: string, authorNickname: string, thumbnailUrl: string } | null}
 */
export function parsePostShareChatMessage(content) {
  if (typeof content !== 'string' || !content.startsWith(POST_SHARE_CHAT_PREFIX)) {
    return null;
  }
  try {
    const raw = JSON.parse(content.slice(POST_SHARE_CHAT_PREFIX.length));
    const id = Number(raw.id);
    if (!id) return null;
    return {
      id,
      title: typeof raw.title === 'string' ? raw.title : '',
      authorNickname: typeof raw.authorNickname === 'string' ? raw.authorNickname : '',
      thumbnailUrl: typeof raw.thumbnailUrl === 'string' ? raw.thumbnailUrl : '',
    };
  } catch {
    return null;
  }
}
